import {
  Grid,
  Card, CardContent, Checkbox, InputAdornment, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, TextField, Typography,
} from "@mui/material";
import React, { useState } from "react";
import NumberFormat from "react-number-format";

const personsNum = [...Array(9).keys()].slice(1);

const IncomeBracket: React.FC<{title: string, alias: string}> = ({ title, alias }) => {
  const [enabled, setEnabled] = useState(false);
  const toggleEnabled = () => setEnabled(!enabled);
  return <Grid size={{ xs: 12, xl: 6 }}>
    <Card>
      <CardContent>
        <Typography variant="h6"><Checkbox checked={enabled} onClick={toggleEnabled}/>{title}</Typography>
        <TableContainer>
          <Table style={{ minWidth: 0 }} size="small">
            <TableHead>
              <TableRow>
                <TableCell width="30%"># of People</TableCell>
                <TableCell>Yearly Income Limit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {personsNum.map((number) => {
                const label = number === 1 ? "1 Person" : `${number} People`;
                return { key: `${alias}.n${number}`, label };
              }).map(({ key, label }) => (<TableRow key={key}>
                <TableCell>
                  {label}
                </TableCell>
                <TableCell>
                  <NumberFormat
                    disabled={!enabled}
                    fullWidth
                    allowNegative={false}
                    variant="outlined"
                    margin="dense"
                    label="Income Limit"
                    name="income"
                    customInput={TextField}
                    prefix="$"
                    type="text"
                    thousandSeparator
                    InputProps={{
                      endAdornment: <InputAdornment position="end">/yr</InputAdornment>,
                    }}
                  />
                </TableCell>
              </TableRow>))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  </Grid>;

};

export default IncomeBracket;
